import { type MouseEvent as ReactMouseEvent } from 'react';

import { isLinkAction } from '../../../../core/components/series-action/utils/is-link-action.js';

/**
 * Hook responsible to return the handler called when clicking on a category action.
 * When the tooltip has multiple entries, the handler keeps it open after a click.
 * In both cases it stops propagation to avoid unexpected side effects.
 * @param hasMultipleItems -
 */
export const useSeriesActionClickHandler = (hasMultipleItems: boolean) => {
  const multiItemsActionClickHandler = (e: ReactMouseEvent) => {
    if (!isLinkAction(e.target as HTMLElement)) {
      e.preventDefault();
    }
    // needed to avoid the propagation of the event that in some cases
    // introduce unexpected behaviors (e.g. unpinning tooltip)
    e.stopPropagation();
  };

  const singleItemActionClickHandler = (e: ReactMouseEvent) => {
    // needed to avoid the propagation of the event that in some cases
    // introduce unexpected behaviors (e.g. re-pinning the tooltip at the
    // click coordinates instead of leaving it pinned where it was)
    e.stopPropagation();
  };

  return hasMultipleItems
    ? multiItemsActionClickHandler
    : singleItemActionClickHandler;
};
